/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.9.3",
  "gitBuildTime": "2026-09-25T14:24:48.509Z",
  "gitBuildVersion": "2.9.3",
  "gitCommitId": "a1b6807",
  "gitCommitIdFull": "a1b68077557cfbc1bc9e69e9736070e705a31e39",
  "gitCommitTime": "2026-09-25T14:23:13.000Z",
  "version": "2.9.3-2026-09-25T14:23:13.000Z-(a1b6807)"
};
